/* eslint-disable max-len */
import cx from 'clsx';
// styles
import { useStyles } from './shared/styles';

const AiLoader = ({ className, color, onClick, ...rest }) => {
  const classes = useStyles();
  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      onClick={onClick}
      width="32"
      height="32"
      viewBox="0 0 42 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect width="6" height="40" rx="3" fill="#0374DD" />
      <rect x="12" y="4" width="6" height="32" rx="3" fill="#64B3FD" />
      <rect x="24" y="8" width="6" height="24" rx="3" fill="#8EC8FD" />
      <rect x="36" y="12" width="6" height="16" rx="3" fill="#B8DDFE" />
    </svg>
  );
};

export default AiLoader;
